<template>
  <wizard
    first-step="personalDetails"
    class="wizard-request-direct-debit-authorization"
  >
    <wizard-step
      :i18n="i18n"
      name="personalDetails"
      :model="formData"
      next-step="review"
    >
      <wizard-step-intro>
        <h2>{{ i18n.wizardSteps.personalDetails.title }}</h2>
        <slot name="personal-details-paragraph" />
      </wizard-step-intro>

      <fieldset>
        <FormulateInput
          name="bonusCode"
          type="text"
          label="bonus code"
          validation="nohtml"
          class="custom-form-element"
          aria-hidden="true"
        />
        <FormulateInput
          name="website"
          type="text"
          label="website"
          validation="nohtml"
          class="custom-form-element"
          aria-hidden="true"
        />
        <FormulateInput
          name="email"
          type="email"
          :label="i18n.form.labels.email"
          validation="bail|required:trim|email"
          :validation-messages="i18n.form.validations.email"
        />
        <FormulateInput
          type="text"
          name="debtorNumber"
          :label="i18n.form.labels.debtorNumber"
          :help="i18n.form.help.debtorNumber"
          validation="bail|required:trim|max:9,length|min:6,length|nohtml|matches:/^[0-9\-]+$/"
          validation-name="Klantnummer"
          :validation-messages="i18n.form.validations.debtorNumber"
          @keydown.space.prevent
        />
      </fieldset>
    </wizard-step>

    <wizard-step
      :i18n="i18n"
      name="review"
      :model="formData"
      :next-step="sendRequest"
      previous-step="personalDetails"
      :submit-button-text="i18n.form.buttons.submit"
      :is-submitting="request.isSending"
      :error-submitting="request.errorSending"
    >
      <wizard-step-intro>
        <h2>{{ i18n.wizardSteps.review.title }}</h2>
        <slot name="review-paragraph" />
      </wizard-step-intro>

      <table class="wizard-summary">
        <tbody>
          <tr>
            <th>{{ i18n.form.labels.reviewEmail }}</th>
            <td>{{ resultingData.personalDetails.email }}</td>
          </tr>
          <tr>
            <th>{{ i18n.form.labels.reviewCustomerNumber }}</th>
            <td>{{ resultingData.personalDetails.debtorNumber }}</td>
          </tr>
        </tbody>
      </table>
    </wizard-step>
  </wizard>
</template>

<script>
  import Wizard from '@/components/wizards/components/Wizard.vue';
  import WizardStep from '@/components/wizards/components/WizardStep.vue';
  import WizardStepIntro from '@/components/wizards/components/WizardStepIntro.vue';
  import getQueryParams from '@/lib/formulate/getFormQueryParam';
  import axios from 'axios';

  export default {
    name: 'KfWizardRequestDirectDebitAuthorization',
    components: {
      Wizard,
      WizardStep,
      WizardStepIntro,
    },
    props: {
      i18n: {
        type: Object,
        default: null,
      },
      prefillData: {
        type: Object,
        default: () => { },
      },
      locale: {
        type: String,
        default: () => 'nl',
      },
      label: {
        type: String,
        default: 'Partou',
      },
      successPageUrl: {
        type: String,
        default: () => '/',
      },
      formToken: {
        type: String,
        default: () => '',
      },
    },
    data() {
      return {
        formData: {
          personalDetails: {},
        },
        request: {
          isSending: false,
          errorSending: false,
        },
      };
    },
    computed: {
      resultingData() {
        return {
          label: this.label,
          locale: this.locale,
          formToken: this.formToken,
          personalDetails: this.formData.personalDetails,
        };
      },
    },
    created() {
      this.formData.personalDetails = {
        ...this.formData.personalDetails,
        ...getQueryParams(this.prefillData)
      }
    },
    methods: {
      sendRequest() {
        this.request.errorSending = false;
        this.request.isSending = true;

        const requestVerificationToken = document.body.querySelector('input[type=hidden][name=__RequestVerificationToken]').value;

        const config = {
          headers: {
            'X-REQUEST-VERIFICATION-TOKEN': requestVerificationToken,
          }
        };

        axios
          .post('/umbraco/api/wizard/requestdirectdebitauthorization', this.resultingData, config)
          .then(() => {
            window.location.href = this.successPageUrl;
          })
          .catch(() => {
            this.request.isSending = false;
            this.request.errorSending = true;
          });
      },
    },
  };
</script>
